import type { CourseModule } from "@/core/types";
import { lektionWasserzeichen } from "./lektion-01-wasserzeichen";
import { lektionSpalten } from "./lektion-02-spalten";
import { lektionSeiteEinrichten } from "./lektion-03-seite-einrichten";

/**
 * Die Registerkarten „Entwurf“ und „Layout“ jenseits von Rändern und
 * Umbrüchen. Spalten, Papierformat und Zeilennummern kommen aus
 * WordApiDesktop 1.3 – in Word 2019/2021 übernimmt das Prüfmakro
 * „Dokument auslesen“. Die Seitenfarbe kennt nur VBA.
 */
export const modulSeitengestaltung: CourseModule = {
  id: "seitengestaltung",
  title: "Seite gestalten",
  summary:
    "Wasserzeichen, Seitenfarbe und Seitenrahmen, Textspalten mit Spaltenumbruch, " +
    "Papierformat, Zeilennummern und eine abweichende erste Seite.",
  level: "Grundlagen",
  lessons: [lektionWasserzeichen, lektionSpalten, lektionSeiteEinrichten],
};
